export default __webpack_public_path__ + "static/media/private-group.01b98fbc.svg";